import React, { useEffect, useState } from 'react';
import { generatePath, Link } from 'react-router-dom';
import { Accordion, AccordionDetails, AccordionSummary, Box, Breadcrumbs, Grid, Typography } from '@mui/material';
import {
  Home as HomeIcon,
  ExpandMore as ExpandMoreIcon,
  Videocam as VideocamIcon,
  VpnKey as VpnKeyIcon,
  CheckCircleOutline as CheckCircleOutlineIcon,
  CheckBox as CheckBoxIcon,
} from '@mui/icons-material';
import {
  StyledRescuerBreadcrumb,
  StyledRescuerTextBreadcrumb,
} from '../../rescuerDashboard/rescuerDashboardMobile/Components/StyledRescuerBreadcrumb';
import routes from '../../../routes';
import CourseModuleItem from '../Components/CourseModuleItem';
import { Colors } from '../../../assets/theme/Colors';
import OverlayLoader from '../../../components/OverlayLoader';

export const VIDEO_MODULE_NAME = 'VIDEO';
export const NEED_TO_KNOW_MODULE_NAME = 'NEED_TO_KNOW';
export const QUIZ_MODULE_NAME = 'QUIZ';

const LearningCenterMobileBreadcrumbs = () => (
  <Box boxShadow={0}>
    <Breadcrumbs aria-label="breadcrumb">
      <StyledRescuerBreadcrumb
        component={Link}
        to={generatePath(routes.mobileDashboard)}
        label="Home"
        icon={<HomeIcon style={{ color: '#fff' }} fontSize="small" />}
      />
      <StyledRescuerTextBreadcrumb component="a" href="#" label="Learn" />
    </Breadcrumbs>
  </Box>
);

const LearningCenterMobileView = ({
  isLoading,
  videoTab,
  needToKnowTab,
  quizTab,
  courses,
  onModuleClick,
  coursesState,
  userId,
}) => {
  const [isExpaned, setIsExpanded] = useState();
  const currentUserCoursesState = coursesState[userId];

  useEffect(() => {
    if (currentUserCoursesState) {
      setIsExpanded(currentUserCoursesState?.activeCourse);
    }
  }, [currentUserCoursesState]);

  return (
    <>
      <LearningCenterMobileBreadcrumbs />
      <OverlayLoader isLoading={isLoading}>
        <Box
          sx={{
            height: '100%',
            width: '100%',
            overflow: 'auto',
            backgroundColor: 'background.default',
            flexDirection: 'column',
            padding: 1,
          }}
        >
          <Typography variant="h6">Learn About Food Rescue</Typography>

          <Box my={2}>
            {courses.map((course) => {
              const videoModule = (course.modules || []).find((module) => module.name === VIDEO_MODULE_NAME);
              const needToKnowModule = (course.modules || []).find(
                (module) => module.name === NEED_TO_KNOW_MODULE_NAME
              );
              const quizModule = (course.modules || []).find((module) => module.name === QUIZ_MODULE_NAME);
              const allModulesFinished = (course?.modules || []).every((module) => module.completed);
              return (
                <Accordion
                  elevation={25}
                  sx={{
                    '&.Mui-expanded': {
                      margin: 0,
                    },
                  }}
                  key={course.id}
                  expanded={isExpaned === course.id}
                  onClick={() => (isExpaned !== course.id ? setIsExpanded(course.id) : setIsExpanded(null))}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    sx={{
                      position: 'relative',
                      fontWeight: 'bold',
                      display: 'flex',
                      alignItems: 'center',
                      '&.Mui-expanded': {
                        minHeight: '50px',
                      },
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                      <span style={{ flexGrow: 1 }}>{course.title}</span>
                      {allModulesFinished && <CheckBoxIcon sx={{ color: Colors.green.light }} />}
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container>
                      <Grid item xs={12}>
                        <CourseModuleItem
                          onClick={() => onModuleClick(videoTab, course)}
                          icon={<VideocamIcon />}
                          title="Video"
                          duration={course.videoDuration}
                          done={videoModule?.completed}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <CourseModuleItem
                          onClick={() => onModuleClick(needToKnowTab, course)}
                          icon={<VpnKeyIcon />}
                          title="Need To Know"
                          duration={course.needToKnowDuration}
                          done={needToKnowModule?.completed}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <CourseModuleItem
                          onClick={() => onModuleClick(quizTab, course)}
                          icon={<CheckCircleOutlineIcon />}
                          title="Quiz"
                          duration={course.quizDuration}
                          done={quizModule?.completed}
                        />
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </Box>
        </Box>
      </OverlayLoader>
    </>
  );
};

export default LearningCenterMobileView;
